import { render, staticRenderFns } from "./PhotoSettingsTemplate.vue?vue&type=template&id=5fd9058d&scoped=true"
import script from "./PhotoSettingsTemplate.vue?vue&type=script&lang=js"
export * from "./PhotoSettingsTemplate.vue?vue&type=script&lang=js"
import style0 from "./PhotoSettingsTemplate.vue?vue&type=style&index=0&id=5fd9058d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9058d",
  null
  
)

export default component.exports